var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-info__content",class:{ 'require-password': _vm.isShowPasswordChecker }},[(_vm.isShowPasswordChecker)?_c('password-checker'):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }